import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmployeeService } from 'src/app/services/employee.service';
import { UtilsService } from 'src/app/services/utils.service';
import { getEmployeeDocumentType, EmployeeDocumentType } from '../document-types';

@Component({
    selector: 'app-employee-document-view',
    templateUrl: './employee-document-view.component.html',
    styleUrls: ['./employee-document-view.component.css']
})
export class EmployeeDocumentViewComponent implements OnInit {
    employeeId!: number;
    docType = '';
    docTypeMeta: EmployeeDocumentType | undefined;
    document: any = null;
    loading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private employeeService: EmployeeService,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            const idParam = params.get('id');
            const typeParam = params.get('type');
            this.employeeId = idParam ? parseInt(idParam, 10) : 0;
            this.docType = typeParam || '';
            this.docTypeMeta = getEmployeeDocumentType(this.docType);
            if (!this.employeeId || !this.docType) return;
            this.loadDocument();
        });
    }

    loadDocument(): void {
        this.loading = true;
        this.spinner.show();
        this.employeeService.getById(this.employeeId).subscribe({
            next: (resp: any) => {
                const documents = Array.isArray(resp?.documents) ? resp.documents : [];
                this.document = documents.find((d: any) => d.document_type === this.docType) || null;
                this.loading = false;
                this.spinner.hide();
            },
            error: () => {
                this.document = null;
                this.loading = false;
                this.spinner.hide();
                this.utils.alertSwal({ title: 'Error', text: 'No se pudo obtener el documento', icon: 'error' });
            }
        });
    }

    get documentUrl(): string | null {
        return this.employeeService.getDocumentUrl(this.document?.file_path);
    }

    get safePdfUrl(): SafeResourceUrl | null {
        const url = this.documentUrl;
        return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
    }

    get isPdf(): boolean {
        return this.document?.mime_type === 'application/pdf';
    }

    get isImage(): boolean {
        return !!this.document?.mime_type && String(this.document.mime_type).startsWith('image/');
    }

    goBack(): void {
        this.router.navigateByUrl(`/employee/${this.employeeId}`);
    }

    print(): void {
        window.print();
    }
}
